export const agreementsResponse = {
  agreementsForSigning: [
    {
      cryptedId: null,
      educationalInstitute: 'Byåsen videregående skole',
      amount: 36008,
      signedDate: null,
      name: 'Stemorsblom, Forvirret',
      createdDate: '2023-03-06T14:05:12.89',
      signedBy: null,
      cryptedDocumentArchiveId: null,
      signingMethod: 0,
      eksterntArkiv: 0,
    },
  ],
  signedAgreements: [
    {
      cryptedId: null,
      educationalInstitute: 'Bybroen videregående skole',
      amount: 36008,
      signedDate: '2022-08-10T00:00:00',
      name: 'Fuglevikke, Lykkelig',
      createdDate: '2023-03-06T13:28:38.283',
      signedBy: 'Vennlig Piano',
      cryptedDocumentArchiveId: null,
      signingMethod: 1,
      eksterntArkiv: 2,
    },
    {
      cryptedId: null,
      educationalInstitute: 'Thora Storm videregående skole',
      amount: 1118,
      signedDate: '2022-08-10T00:00:00',
      name: 'Kjernebiter, Rosa',
      createdDate: '2023-03-06T13:46:21.06',
      signedBy: 'Berømt Kattugle',
      cryptedDocumentArchiveId: null,
      signingMethod: 1,
      eksterntArkiv: 2,
    },
  ],
  harSignertEldreAvtale: true,
  harTjenesteFeilet: false,
};

export type AggrementsResponse = typeof agreementsResponse;
